import Colors from "../utils/colors";
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import Avatar from '@material-ui/core/Avatar';
import Checkbox from '@material-ui/core/Checkbox';

import {loggedInUserId} from '../auth/msalConfig';
import updateImageData, {getUserLetter} from "../utils/avatarUtils";

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
  },
  userRoot: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  },
  vl: {
    borderLeft: '1px solid rgba(0, 0, 0, 0.87)',
    height: '2rem',
    marginLeft: '15%',
    paddingTop: '1rem'
  },
  hl: {
    width: '100%',
    marginBlockStart: '0px'
  },
  textBox: {
    backgroundColor: props => props.bgColor,
    color: 'white',
    padding: '0.5rem'
  },
  managerCardDiv: {
    backgroundColor: props => props.bgColor,
    color: 'white',
    display: 'flex',
    alignContent: 'center',
    width: '31%',
    marginBottom: '1rem'
  },
  secondDiv: {
    backgroundColor: props => props.bgColor,
    color: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    width: '100%',
    cursor: 'pointer'
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-begin',
    flexGrow: 1,
    fontSize: '12px'
  },
  avatarBox: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: '100%',
    paddingRight: '0.5rem'
  }
}));

function ManagerBox({ manager,  changeTeam }) {
  const bgColor = Colors.primary;
  const classes = useStyles({bgColor});

  const [ blobUrl, setBlobUrl] = useState(null);

  const handleDoubleClick = () => {
    changeTeam(manager.oid, false);
  };

  useEffect(() => {
    if (manager) {
      updateImageData(manager, setBlobUrl);
    }
  }, [manager]);

  return (
    <div className={classes.managerCardDiv} onDoubleClick={handleDoubleClick} key={`manager-box-${manager?manager.oid: 'none'}`}>
      <div className={classes.secondDiv}>
      <div className={classes.textBox} >
        {manager? manager.name: ''}
        <div className={classes.title}>
          {manager? manager.title: ''}
        </div>
      </div>
      <div className={classes.avatarBox}>
        <Avatar
          alt={manager?manager.name: ''}
                src={blobUrl}>
          {getUserLetter(manager)}
        </Avatar>
      </div>
      </div>
    </div>
  );
}

function UserBox({ user, filterChange, changeTeam }) {
  let bgColor = Colors.primary;
  if (user.oid === loggedInUserId()) {
    bgColor = Colors.secondary;
  }
  const classes = useStyles({bgColor});

  const [ checked, setChecked ] = useState(false);
  const [ blobUrl, setBlobUrl] = useState(null);

  useEffect(() => {
    if (user) {
      updateImageData(user, setBlobUrl);
    }
  }, [user]);

  const handleChange = () => {
    setChecked(!checked);
    filterChange(user.oid, !checked);
  };

  const handleDoubleClick = () => {
    changeTeam(user.oid, true);
  };

  return (
    <div className={classes.managerCardDiv} onDoubleClick={handleDoubleClick} key={`user-filter-${user.oid}`}>
      <div className={classes.avatarBox}>
        <Checkbox
          checked={checked}
          onChange={handleChange}
          color="default"
          inputProps={{ 'aria-label': 'primary checkbox' }}
        />
      </div>
      <div className={classes.secondDiv}>
        <div className={classes.textBox} >
          <div >
          {user? user.name: ''}
          </div>
          <div className={classes.title}>
            {user? user.title: ''}
          </div>
        </div>
        <div className={classes.avatarBox}>
          <Avatar
            alt={user?user.name: ''}
            src={blobUrl}>
            {getUserLetter(user)}
          </Avatar>
        </div>
      </div>
    </div>
  );
}

export default function MyTeamFilter({  team, filterChange, changeTeam }) {
  let bgColor = Colors.darkBlue;
  let color = 'white';

  const classes = useStyles({bgColor, color});
  return (
    <div className={classes.root} >
      <ManagerBox  manager={team.manager} changeTeam={changeTeam} key={team.manager? `manager-box-${team.manager.oid}` : 'manager-box'}/>
      <div className={classes.vl}/>
      <hr className={classes.hl} />
      <div className={classes.userRoot}>
       {team.team.filter(user => user.oid === loggedInUserId()).map(user =>
         <UserBox user={user} key={`user-filter-${user.oid}`} filterChange={filterChange} changeTeam={changeTeam}/>
       )}
       {team.team.filter(user => user.oid !== loggedInUserId()).map(user =>
         <UserBox user={user} key={`user-filter-${user.oid}`} filterChange={filterChange} changeTeam={changeTeam}/>
       )}
      </div>
    </div>
  );
}
